import * as React from "react";
const SvgFiRrPercent80 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-percent-80_svg__a)">
      <path
        fill="#062147"
        d="M21.122 18.229a1 1 0 0 1 .135 1.408A11.97 11.97 0 0 1 12 24C5.383 24 0 18.617 0 12S5.383 0 12 0a11.97 11.97 0 0 1 9.257 4.363 1 1 0 0 1-1.543 1.274A9.97 9.97 0 0 0 12 2C6.486 2 2 6.486 2 12s4.486 10 10 10a9.97 9.97 0 0 0 7.714-3.637c.352-.426.98-.484 1.408-.134M5.786 11.691a2.23 2.23 0 0 1-.536-1.441A2.25 2.25 0 0 1 7.5 8a2.25 2.25 0 0 1 2.25 2.25c0 .551-.207 1.049-.536 1.441.481.456.785 1.096.785 1.81A2.5 2.5 0 0 1 7.5 16a2.5 2.5 0 0 1-2.499-2.499c0-.714.304-1.354.785-1.81m2.613 1.81a.9.9 0 0 0-.899-.9.9.9 0 0 0 0 1.799.9.9 0 0 0 .899-.899M6.6 10.25a.9.9 0 0 0 .899.899.9.9 0 0 0 .899-.899.9.9 0 0 0-.899-.899.9.9 0 0 0-.899.899M13.499 8a2.5 2.5 0 0 1 2.5 2.5v3a2.5 2.5 0 1 1-5 0v-3a2.5 2.5 0 0 1 2.5-2.5m0 1.6c-.496 0-.9.404-.9.9v3c0 .496.404.9.9.9s.9-.404.9-.9v-3c0-.496-.404-.9-.9-.9m9.25 3.881a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-3.25-4.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-1.156 6.75a.8.8 0 0 0 .67-.363l4.178-6.4a.8.8 0 1 0-1.34-.874l-4.178 6.4a.8.8 0 0 0 .67 1.237"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-percent-80_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPercent80;
